import { AfterContentChecked, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import dayjs from 'dayjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { AnalyticsService } from '../../@core/utils/analytics.service';
import {
  validateEmail,
  validateInputWithNumberNoSpace,
  validateMobileNumber,
  validateNameWithSpecialCharacters,
  validateinputwithNumber,
} from '../../@theme/directives/validators';
import { ROLEVALUES } from '../../enum/roles.enum';
import { User } from '../../interface/user';
import { AuthService } from '../../services/auth.service';
import { NotificationsService } from '../../services/notifications.service';
import { ProfileMediaService } from '../../services/profile-media.service';
import { StorageService } from '../../services/storage.service';
import { ToasterService } from '../../services/toaster.service';
import { UtilService } from '../../services/util.service';
import { MatDialogComponent } from '../mat-dialog/mat-dialog.component';

@Component({
  selector: 'ngx-teacher-profile-portal',
  templateUrl: './teacher-profile-portal.component.html',
  styleUrls: ['./teacher-profile-portal.component.scss'],
  providers: [NgxSpinnerService],
})
export class TeacherProfilePortalComponent implements OnInit, AfterContentChecked {
  teacherPortalInfoForm: FormGroup;
  user: User | any;
  fileMe;
  public modalRef;
  @ViewChild('myModal') myModal;
  @Input() title: string;
  loading = false;
  minDate: Date = new Date();
  minBirthDate = new Date();
  maxDateTbExpiration: any;
  currentProfile;
  currentCriminalClearanceDate: number;
  newCriminalClearanceDate = new Date();
  isModalOpen = false;
  minDateOfHire: Date | null = null;
  minDateOfTB: Date | null = null;
  currentDate: Date = new Date();
  isTeacherOnlyUser: boolean = false;
  validatedTeacherData = [];
  savedValidatedTeacherData;
  @ViewChild('teacherValidatedModal') teacherValidatedModal;
  isFirstNameMismatch: boolean;
  isLastNameMismatch: boolean;

  constructor(
    private fb: FormBuilder,
    private storageService: StorageService,
    private authService: AuthService,
    public router: Router,
    private profileService: ProfileMediaService,
    public modalService: NgbModal,
    private changeDetector: ChangeDetectorRef,
    private toasterService: ToasterService,
    public analyticsService: AnalyticsService,
    public spinner: NgxSpinnerService,
    private utilService: UtilService,
    private notificationService: NotificationsService,
    public dialog: MatDialog,
  ) {
    this.authService.updateValue.subscribe(async (value: string) => {
      if (value) {
        const user = await this.storageService.getItem('user');
        this.user = await this.authService.userById(user.user.id);
      }
    });
  }

  async ngOnInit() {
    this.minBirthDate.setFullYear(this.minDate.getFullYear() - 4);

    this.getFormControls();
    await this.userData();
    this.teacherPortalInfoForm.get('dateOfCriminalBackground')?.valueChanges.subscribe((date) => {
      this.ValidateDateOfHire(date);
    });
    this.teacherPortalInfoForm.get('birthdate')?.valueChanges.subscribe((date) => {
      this.validateDateOfTb(date);
    });

    this.getBirthDate();
    await this.getEssaGridData();
  }

  getBirthDate() {
    const birthDate = new Date(this.teacherPortalInfoForm.value.birthdate);
    birthDate.setDate(birthDate.getDate() + 1);
    this.minDate = birthDate;
  }

  getFormControls() {
    try {
      this.teacherPortalInfoForm = this.fb.group({
        lastName: ['', [Validators.required, validateNameWithSpecialCharacters]],
        firstName: ['', [Validators.required, validateNameWithSpecialCharacters]],
        dateOfCriminalBackground: [''],
        dateOfHire: [''],
        credentialDocumentNumber: ['', [validateInputWithNumberNoSpace]],
        credentialTypeEmployment: [''],
        credentialExpirationDate: [''],
        tbClearanceDate: [''],
        tbExpirationDate: [''],
        contact: ['', [validateMobileNumber]],
        address: [''],
        birthdate: [''],
        email: ['', [Validators.required, validateEmail]],
        id_code: ['', [Validators.required]],
      });
    } catch (error) {
      // console.log(error);
    }
  }

  async userData(isUpdate = false) {
    try {
      const user = this.storageService.getItem('user');
      if (user.user.role_id === ROLEVALUES.TEACHER_ONLY) {
        this.isTeacherOnlyUser = true;
      }
      if (isUpdate) this.modalService.dismissAll(this.modalRef);
      if (user.user.is_trial_user) {
        Object.keys(this.teacherPortalInfoForm.controls).forEach((ctrl) => {
          this.teacherPortalInfoForm.controls[ctrl].disable();
        });
      }
      if (!user.user.is_trial_user) {
        const currentCriminalClearanceDate = new Date(user?.user?.birthdate);
        currentCriminalClearanceDate.setDate(currentCriminalClearanceDate.getDate() + 1);
        this.newCriminalClearanceDate = new Date(currentCriminalClearanceDate);
      }
      this.user = user.user.is_trial_user ? await this.authService.getDummyUser(9, true) : user.user;

      this.user.email = user?.user?.email;

      if (this.title && this.title === 'administration') {
        await this.patchProfileForm(true);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async patchProfileForm(isAdmin = false) {
    try {
      this.onTBClearanceDateChange();

      this.loading = !isAdmin ? true : false;
      this.teacherPortalInfoForm.patchValue({
        lastName: this.user.lastName,
        firstName: this.user.firstName,
        dateOfCriminalBackground: this.user.profileData.dateOfCriminalBackground
          ? new Date(this.user.profileData.dateOfCriminalBackground)
          : null,
        dateOfHire: this.user.profileData.dateOfHire ? new Date(this.user.profileData.dateOfHire) : null,
        credentialDocumentNumber: this.user.profileData.credentialDocumentNumber,
        credentialTypeEmployment: this.user.profileData.credentialTypeEmployment,
        credentialExpirationDate: this.user.profileData.credentialExpirationDate
          ? new Date(this.user.profileData.credentialExpirationDate)
          : null,
        tbClearanceDate: this.user.profileData.tbClearanceDate ? new Date(this.user.profileData.tbClearanceDate) : null,
        tbExpirationDate: this.user.profileData.tbExpirationDate
          ? new Date(this.user.profileData.tbExpirationDate)
          : null,
        email: this.user.email,
        birthdate: this.user?.birthdate ? new Date(this.user?.birthdate) : null,
        address: this.user.address,
        contact: this.user.contact ? this.user.contact : null,
        id_code: this.user?.school_indentity_number ? this.user?.school_indentity_number : '0',
      });

      !isAdmin
        ? (this.modalRef = this.modalService.open(this.myModal, {
            size: 'lg',
            modalDialogClass: 'mymodal',
            centered: true,
            backdrop: 'static',
            animation: true,
            keyboard: false,
            backdropClass: 'modal-backdrop',
            windowClass: 'custom-overlay-container',
          }))
        : null;
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      // console.log(error);
    }
  }

  async submit() {
    try {
      const user = this.storageService.getItem('user');
      if (user.user.is_trial_user && this.router.url.includes('administration')) {
        this.router.navigateByUrl('/administration/teacher-academic-portal');

        return;
      } else if (user.user.is_trial_user && this.router.url.includes('profile')) {
        this.toasterService.showToast('You can update profile from here', 'info');
        return;
      }

      this.spinner.show();

      if (this.teacherPortalInfoForm.valid) {
        const isUserExist = await this.authService.userByIndentityCode({
          school_identity_code: this.teacherPortalInfoForm?.value?.id_code,
          school_id: this.user.school_id,
          user_id: this.user.id,
        });

        // commented creating problem for SSO login
        // if (isUserExist?.length > 0) {
        //   this.toasterService.showToast('Duplicate Identity Number Found', 'danger');
        //   this.spinner.hide();
        //   return;
        // }

        const body = {
          user_id: this.user.id,
          firstName: this.teacherPortalInfoForm.value.firstName,
          lastName: this.teacherPortalInfoForm.value.lastName,
          email: this.teacherPortalInfoForm.value.email,
          role_id: this.user.role_id,
          school_id: this.user.school_id,
          isNewUser: this.user?.isNewUser,
          password: this.user.password,
          profileData: await this.profileInformation(),
          teachingInfo: this.user.teachingInfo,
          user_profile_media_id: this.user?.user_profile_media_id,
          contact: Number(this.teacherPortalInfoForm?.value?.contact),
          address: this.teacherPortalInfoForm.value.address,
          birthdate: this.teacherPortalInfoForm.value.birthdate
            ? this.teacherPortalInfoForm.value.birthdate.getTime()
            : null,
          school_indentity_number: this.teacherPortalInfoForm?.value?.id_code,
          is_trial_user: this.user.is_trial_user,
          uid: user.user.uid,
          provider_id: this.user.provider_id,
          proxy_email: this.user.proxy_email,
          last_login_location: this.user.last_login_location,
        };

        const updateUser = await this.authService.updateUser(this.user.id, body, true);
        if (updateUser) {
          const storageData = await this.storageService.getItem('user');
          this.storageService.removeItem('user');
          storageData.user = updateUser;
          this.storageService.setItem('user', storageData);

          this.title === 'profile'
            ? await this.userData(true)
            : this.router.navigateByUrl('/administration/teacher-academic-portal');
          this.authService.updateValue.next(true);
        }
      } else {
        Object.keys(this.teacherPortalInfoForm.controls).forEach((field) => {
          const control = this.teacherPortalInfoForm.get(field);

          control.markAsTouched({
            onlySelf: true,
          });
        });
      }

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.log(error);
    }
  }

  async profileInformation() {
    try {
      const checkDate = (date) => (date ? date.getTime() : null);

      const profile = {
        dateOfCriminalBackground: checkDate(this.teacherPortalInfoForm.value.dateOfCriminalBackground),
        dateOfHire: checkDate(this.teacherPortalInfoForm.value.dateOfHire),
        credentialDocumentNumber: this.teacherPortalInfoForm.value.credentialDocumentNumber || null,
        credentialTypeEmployment: this.teacherPortalInfoForm.value.credentialTypeEmployment || null,
        credentialExpirationDate: checkDate(this.teacherPortalInfoForm.value.credentialExpirationDate),
        tbClearanceDate: checkDate(this.teacherPortalInfoForm.value.tbClearanceDate),
        tbExpirationDate: checkDate(this.teacherPortalInfoForm.value.tbExpirationDate),
        currentRoute: '/administration/teacher-academic-portal',
      };
      return profile;
    } catch (error) {
      // console.log(error);
    }
  }

  async pickFiles(event) {
    this.spinner.show();
    this.fileMe = event.target.files[0];
    await this.setUserProfile();
  }

  async setUserProfile() {
    try {
      const data = new FormData();
      const fileName = this.fileMe.name.toLowerCase().replace(/ /g, '-');
      data.append('image', this.fileMe, fileName);

      if (this.user.user_profile_media_id > 0) {
        data.append('user_profile_media_id', this.user.user_profile_media_id);
        this.isModalOpen
          ? await this.addProfile(data)
          : await this.updateProfile(data, this.user.user_profile_media_id);
      } else {
        await this.addProfile(data);
      }
      this.spinner.hide();
    } catch (error) {
      // console.log(error);
      this.spinner.hide();
    }
  }

  async updateProfile(data, profileId) {
    try {
      const response: any = await this.profileService.updateProfile(data, profileId);
      if (response?.id) await this.updateUserData(response?.id);
    } catch (error) {
      // console.log(error);
    }
  }

  async addProfile(data) {
    try {
      const profileData: any = await this.profileService.uploadProfile(data);

      const profileId = profileData?.id;
      if (this.isModalOpen) {
        this.user['user_profile_media_id'] = profileId;
        this.currentProfile = profileData;
      } else {
        await this.updateUserData(profileId);
      }
    } catch (error) {
      // console.log(error);
    }
  }

  async updateUserData(profileId) {
    try {
      const body = {
        user_id: 0,
        firstName: this.user?.firstName,
        lastName: this.user?.lastName,
        email: this.user?.email,
        role_id: this.user?.role_id,
        school_id: this.user?.school_id,
        isNewUser: this.user?.isNewUser,
        profileData:
          !this.router.url.includes('administration') && !this.isModalOpen
            ? this.user?.profileData
            : await this.profileInformation(),
        teachingInfo: this.user?.teachingInfo,
        user_profile_media_id: profileId,
        contact: this.teacherPortalInfoForm?.value?.contact
          ? Number(this.teacherPortalInfoForm?.value?.contact)
          : this.user?.contact,
        address: this.teacherPortalInfoForm.value.address
          ? this.teacherPortalInfoForm.value.address
          : this.user?.address,
        birthdate: this.teacherPortalInfoForm?.value?.birthdate
          ? this.teacherPortalInfoForm?.value?.birthdate?.getTime()
          : this.user?.birthdate,
        school_indentity_number: this.user?.school_indentity_number,
      };
      const response: any = await this.authService.updateUser(this.user.id, body);
      if (response && response.id) {
        await this.userData();
        this.authService.updateValue.next(true);
        this.storageService.getItem('user');
      }
    } catch (error) {
      // console.log(error);
    }
  }

  onTBClearanceDateChange(event?: MatDatepickerInputEvent<Date>) {
    try {
      const newDate = event ? new Date(event?.value) : new Date(this.user?.profileData?.tbClearanceDate);
      newDate.setFullYear(newDate.getFullYear() + 4);
      this.maxDateTbExpiration = newDate;
      this.teacherPortalInfoForm.patchValue({
        tbExpirationDate: this.maxDateTbExpiration,
      });
    } catch (error) {
      //  console.log(error);
    }
  }
  onBirthDateChange(event?: MatDatepickerInputEvent<Date>) {
    try {
      const birthDate = event?.value || new Date(this.teacherPortalInfoForm.value.birthdate);
      const nextDay = new Date(birthDate);
      nextDay.setDate(nextDay.getDate() + 1);
      if (this.teacherPortalInfoForm.value.birthdate >= this.teacherPortalInfoForm.value.dateOfCriminalBackground) {
        this.teacherPortalInfoForm.patchValue({
          dateOfCriminalBackground: '',
        });
      }
      this.minDate = nextDay;
      this.newCriminalClearanceDate = nextDay;
    } catch (error) {
      console.error('Error updating dates:', error);
    }
  }

  // onBirthDateChange(event?: MatDatepickerInputEvent<Date>) {
  //   try {
  //     const newDate = event ? new Date(event?.value) : new Date(this.user?.profileData?.birthdate);
  //     newDate.setDate(newDate.getDate() + 1);
  //     this.newCriminalClearanceDate = newDate;
  //   } catch (error) {
  //     //  console.log(error);
  //   }
  // }

  deleteProfileIfExist() {
    if (this.currentProfile && this.currentProfile.id) {
      this.profileService.deleteProfile(this.currentProfile.id);
    }
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  ValidateDateOfHire(criminalBackgroundDate: Date | null) {
    if (criminalBackgroundDate) {
      const nextDay = new Date(criminalBackgroundDate);
      nextDay.setDate(nextDay.getDate() + 1); // Set to the next day
      this.minDateOfHire = nextDay;
    } else {
      this.minDateOfHire = null; // Reset if no date is present
    }
  }

  validateDateOfTb(birthDate: Date) {
    if (birthDate) {
      const nextDay = new Date(birthDate);
      nextDay.setDate(nextDay.getDate() + 1); // Set to the next day
      this.minDateOfTB = nextDay;
    } else {
      this.minDateOfTB = null; // Reset if no date is present
    }
  }

  /**
   * @description Validate the credential document number
   * @returns Promise<void>
   */
  async validateCredentialDocumentNumber(): Promise<void> {
    try {
      this.modalService.dismissAll();
      if (this.teacherPortalInfoForm.value.credentialDocumentNumber) {
        this.spinner.show();
        const response = await this.utilService.validateDocumentNumber(
          this.teacherPortalInfoForm.value.credentialDocumentNumber,
        );
        this.validatedTeacherData = [response.detailData, ...response.authorizations];

        if (this.validatedTeacherData.length > 0) {
          this.checkDetailsOfDocument();
          this.openValidateTeacherModal();
        }

        this.spinner.hide();
      }
    } catch (error) {
      this.spinner.hide();
      console.log('validateCredentialDocumentNumber -> error', error);
      this.toasterService.showToast(error.error.error, 'danger');
    }
  }

  openValidateTeacherModal(): void {
    try {
      this.modalService.open(this.teacherValidatedModal, {
        size: 'lg',
        modalDialogClass: 'mymodal',
        centered: true,
        backdrop: 'static',
        animation: true,
        keyboard: false,
        backdropClass: 'modal-backdrop',
        windowClass: 'custom-overlay-container',
      });
    } catch (error) {
      console.log('openValidateTeacherModal -> error', error);
    }
  }

  async handleSaveChanges() {
    try {
      const selectedAuthorizations = this.validatedTeacherData
        .slice(1) // Skip the first entry
        .filter((auth) => auth.checked) // Only include checked items
        .map((auth) => ({
          authorizationCode: auth.authorizationCode,
          authorizationDescription: auth.authorizationDescription,
          subjectCode: auth.subjectCode,
          subjectDescription: auth.subjectDescription,
          checked: auth.checked,
        }));

      if (selectedAuthorizations.length === 0) {
        this.toasterService.showToast('Please select authorization subject before saving.', 'warning');
        return;
      }

      const body = {
        ...this.user,
        profileData: {
          ...this.user.profileData,
          credentialDocumentNumber: this.validatedTeacherData[0].documentNumber,
        },
      };

      const updateUser = await this.authService.updateUser(this.user.id, body, true);

      if (updateUser) {
        const storageData = await this.storageService.getItem('user');

        this.storageService.removeItem('user');
        storageData.user = updateUser;
        this.storageService.setItem('user', storageData);
        this.authService.updateValue.next(true);
      }

      this.validateTeacherWithName();
    } catch (error) {
      console.log(
        '🚀 ~ teacher-profile-portal.component.ts:522 ~ TeacherProfilePortalComponent ~ handleSaveChanges ~ error:',
        error,
      );
    }
  }

  /**
   * @description Save the validated teacher data
   * @returns Promise<void>
   */
  async saveValidatedTeacherData(): Promise<void> {
    try {
      this.spinner.show();
      const selectedAuthorizations = this.validatedTeacherData
        .slice(1) // Skip the first entry
        .filter((auth) => auth.checked) // Only include checked items
        .map((auth) => ({
          authorizationCode: auth.authorizationCode,
          authorizationDescription: auth.authorizationDescription,
          subjectCode: auth.subjectCode,
          subjectDescription: auth.subjectDescription,
          checked: auth.checked,
        }));

      const documentBody = {
        user_id: this.user.id,
        doj_clearance: '',
        doj_expiration: this.validatedTeacherData[0].expirationDate,
        date_of_hire: this.validatedTeacherData[0].issueDate,
        status: this.validatedTeacherData[0].status,
        document_number: this.validatedTeacherData[0].documentNumber,
        subject_authorization: selectedAuthorizations.length > 0 ? selectedAuthorizations : [],
      };
      this.sendCredentialExpireNotifiocation();
      // first will check if record exist for the same user
      const checkIfRecordAlreadyExists = await this.authService.getDocumentsDataByUserId(this.user.id);
      if (checkIfRecordAlreadyExists && checkIfRecordAlreadyExists['id']) {
        // if record exist then update the record
        await this.authService.updateDocumentDataById(checkIfRecordAlreadyExists['id'], documentBody);
      } else {
        // if record not exist then create a new record
        await this.authService.addDocumentData(documentBody);
      }

      this.modalService.dismissAll();
      await this.getEssaGridData();
      this.spinner.hide();
    } catch (error) {
      console.log('saveValidatedTeacherData -> error', error);
      this.modalService.dismissAll();
      this.spinner.hide();
    }
  }

  /**
   * @description Get the ESA grid data
   * @returns Promise<void>
   */

  async getEssaGridData(): Promise<void> {
    try {
      const response = await this.authService.getDocumentsDataByUserId(this.user.id);
      this.savedValidatedTeacherData = response;
    } catch (error) {
      console.log('getEssaGridData -> error', error);
    }
  }
  async sendCredentialExpireNotifiocation() {
    const dojExpirationDate = this.validatedTeacherData[0].expirationDate;
    const currentDate = dayjs();
    const dojExpiration = dayjs(dojExpirationDate);
    // Calculate the number of days remaining until expiration
    const daysUntilDojExpiration = dojExpiration.diff(currentDate, 'day');
    if (daysUntilDojExpiration <= 90 && daysUntilDojExpiration >= 0) {
      const params = {
        school_id: this.user.school_id,
        role_id: [13, 17, 12, 14, 15],
      };
      const adminUsers = await this.authService.getUserByRoleIdAndSchoolId(params);
      const adminUsersArray = Object.values(adminUsers);
      const notificationsToAdd = {
        notifications: [],
      };
      for (const iterator of adminUsersArray) {
        const newNotification = {
          title: 'Credential document expire soon..',
          message: `${this.user.firstName + ' ' + this.user.lastName} has credential document expiring soon`,
          table_reference: 'credential-document',
          read_status: false,
          user_id: this.user.id,
          recieved_to: iterator.id, // Use `iterator.id`
        };
        notificationsToAdd.notifications.push(newNotification);
      }
      const body = {
        title: 'Credential document expire soon.',
        message: 'Your credential document is expiring soon. Please renew it promptly.',
        table_reference: 'credential-document',
        read_status: false,
        user_id: this.user.id,
        recieved_to: this.user.id,
      };
      notificationsToAdd.notifications.push(body);
      await this.notificationService.addMultipleNotifications(notificationsToAdd);
    }
  }

  checkDetailsOfDocument() {
    const documentFirstName = this.validatedTeacherData[0].firstName.toLowerCase().trim();
    const documentLastName = this.validatedTeacherData[0].lastName.toLowerCase().trim();
    const firstName = this.user.firstName.toLowerCase().trim();
    const lastName = this.user.lastName.toLowerCase().trim();

    this.isFirstNameMismatch = documentFirstName !== firstName;
    this.isLastNameMismatch = documentLastName !== lastName;
  }

  validateTeacherWithName() {
    try {
      if (this.validatedTeacherData.length > 0) {
        if (!this.isFirstNameMismatch && !this.isLastNameMismatch) {
          this.saveValidatedTeacherData();
        } else {
          const dialogRef = this.dialog.open(MatDialogComponent, {
            width: '400px',
            disableClose: true,
            data: {
              title: 'Please Document Number Provided.',
              icon: '/assets/icons/featured icon.svg',
              accessCodeLabel: 'Please Check Provided Document Number',
              confirmationMessage:
                'The number you provided does not match our records. Please check and enter correct document number',

              cancelButtonText: 'Cancel',
              confirmButtonText: 'Proceed',
              cancelTrackEvent: 'Cancel Incorrect Document Number Provided.',
              confirmTrackEvent: 'Incorrect Document Number Provided.',
              trackPage: 'Incorrect',
            },
          });
          this.spinner.hide();
          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              this.saveValidatedTeacherData();
            }
          });
        }
      }
    } catch (error) {
      console.log(
        '🚀 ~ teacher-profile-portal.component.ts:662 ~ TeacherProfilePortalComponent ~ validateTeacherWithName ~ error:',
        error,
      );
    }
  }
}
